var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13 10.3137 10.3137 13 7 13M13 7C13 3.68629 10.3137 1 7 1M13 7H1M7 13C3.68629 13 1 10.3137 1 7M7 13C8.99384 13 10.6102 10.3137 10.6102 7C10.6102 3.68629 8.99384 1 7 1M7 13C5.00616 13 3.38983 10.3137 3.38983 7C3.38983 3.68629 5.00616 1 7 1M7 13C7.67397 13 8.22034 10.3137 8.22034 7C8.22034 3.68629 7.67397 1 7 1M7 13C6.32603 13 5.77966 10.3137 5.77966 7C5.77966 3.68629 6.32603 1 7 1M1 7C1 3.68629 3.68629 1 7 1M2.52542 3.0339H11.5M2.5 10.9661H11.5",
    stroke: "#333333",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/icon-globe.b1f8bd4416c120cf4dcd03808cfc09c2.svg";
export { ForwardRef as ReactComponent };